import { render, staticRenderFns } from "./selectPoint.vue?vue&type=template&id=12816c4a&scoped=true&"
import script from "./selectPoint.vue?vue&type=script&lang=js&"
export * from "./selectPoint.vue?vue&type=script&lang=js&"
import style0 from "./selectPoint.vue?vue&type=style&index=0&id=12816c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12816c4a",
  null
  
)

export default component.exports